export const SHOPIFY_EXPRESS_LIBRARY_VERSION = '8.0.0';
